// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://erlfsougrkzbgonumhoa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVybGZzb3Vncmt6YmdvbnVtaG9hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5NjMyMjIsImV4cCI6MjA1NzUzOTIyMn0.TRDZlAhYRDavo4ICaEgb9EKryo4qRJDoyhlz5udr8p8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);